const pw = "Picky1one!";

export default pw;
